'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_types$IpPayload(kind, ip) {
  this.KO = null;
  this.DV = null;
  this.KO = kind;
  this.DV = ip;
}
export { $c_Lpresto_types$IpPayload as $c_Lpresto_types$IpPayload };
$p = $c_Lpresto_types$IpPayload.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$IpPayload;
/** @constructor */
function $h_Lpresto_types$IpPayload() {
}
export { $h_Lpresto_types$IpPayload as $h_Lpresto_types$IpPayload };
$h_Lpresto_types$IpPayload.prototype = $p;
$p.x = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_util_hashing_MurmurHash3$().S(this, (-889275714), false);
});
$p.i = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lpresto_types$IpPayload)) {
    var x = this.KO;
    var x$2 = x$0.KO;
    if ((x === x$2)) {
      return (this.DV === x$0.DV);
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.l = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_ScalaRunTime$().H(this);
});
$p.r = (function() {
  return 2;
});
$p.s = (function() {
  return "IpPayload";
});
$p.j = (function(n) {
  if ((n === 0)) {
    return this.KO;
  }
  if ((n === 1)) {
    return this.DV;
  }
  throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.GH = (function() {
  return this.KO;
});
function $isArrayOf_Lpresto_types$IpPayload(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.jU)));
}
export { $isArrayOf_Lpresto_types$IpPayload as $isArrayOf_Lpresto_types$IpPayload };
var $d_Lpresto_types$IpPayload = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$IpPayload, "presto.types$IpPayload", ({
  jU: 1,
  d9: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lpresto_types$IpPayload as $d_Lpresto_types$IpPayload };
//# sourceMappingURL=presto.types$-Ip-Payload.js.map
